import {User} from '@ui/types/user';
import {Track} from '@app/web-player/tracks/track';
import {Genre} from '@app/web-player/genres/genre';
import {Tag} from '@common/tags/tag';

export const PLAYLIST_MODEL = 'playlist';

export interface Playlist {
  id: number;
  name: string;
  public: boolean;
  collaborative: boolean;
  image: string;
  description: string;
  created_at: string;
  updated_at: string;
  owner_id: number;
  playlist_series_id?: number | null;
  playlist_generator_id?: number | null;
  source_playlist_id?: number | null;
  snapshot_generated_at?: string | null;
  playlist_series?: {
    id: number;
    name: string;
    model_type: string;
  } | null;
  owner?: User;
  editors?: User[];
  genres?: Genre[];
  tags?: Tag[];
  tracks_count?: number;
  tracks?: Track[];
  is_automatic?: boolean;
  auto_update_interval_days?: number | null;
  auto_schedule_cron?: string | null;
  auto_create_new_playlist?: boolean;
  auto_filter_mode?: 'or' | 'and' | null;
  auto_max_tracks_per_artist?: number | null;
  auto_max_tracks?: number | null;
  auto_boost_new_releases?: boolean;
  auto_rotation_days?: number | null;
  auto_popularity_ratio?: number | null;
  auto_last_generated_at?: string | null;
  auto_title_pattern?: string | null;
  auto_counter?: number | null;
  model_type: typeof PLAYLIST_MODEL;
  views: number;
}
